
export default {
  name: 'fileUploaderPrice',
  data () {
    return {
      file: null
    }
  },
  methods: {
    clearFiles () {
      this.$refs['file-input'].reset()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/components/fileUploaderPrice/fileUploaderPrice.js